import { DocumentLanguages } from "../../../documents/documentTypes";

export const buildReportNumber = (protoNo?: string) => {
    if (!protoNo?.trim()) return "";
    if (/-P$/i.test(protoNo.trim())) {
        return protoNo.trim().replace(/-P$/i, "-R");
    }
    return protoNo.trim().endsWith("-R") ? protoNo.trim() : `${protoNo.trim()}-R`;
};

export const buildReportTitle = (protoTitle?: string) => {
    const base = (protoTitle || "").trim();
    if (!base) return "(Report)";
    return /\(Report\)\s*$/i.test(base) ? base : `${base} (Report)`;
};

export const buildDocumentNumberByProcess = (processNumber?: string | null, type?: string) => {
    
    if (!processNumber || !type) return "";
    const t = String(type).toUpperCase();
    return `${processNumber}-${t}`;
};

export const buildDocumentTitleByProcess = (
    langCode?: DocumentLanguages,
    type?: string,
    dev?: { name?: string; serialNo?: string }
) => {
    const lc = (langCode ?? "").toUpperCase() as DocumentLanguages;
    const t = (type ?? "").trim().toUpperCase();
    if (!lc || !t) return "";

    const isEN = lc === "EN";
    const docWord = isEN ? "Document" : "Dokument";
    const forWord = isEN ? "for" : "dla";
    const snWord = "S/N";
    const name = (dev?.name ?? "").trim();
    const sn = ( dev?.serialNo ?? "").trim();

    let devicePart = "";
    if (name && sn) devicePart = `${name} (${snWord} ${sn})`;
    else if (name) devicePart = name;
    else if (sn) devicePart = `(${snWord} ${sn})`;

    return devicePart
        ? `${docWord} ${t} ${forWord} ${devicePart}`
        : `${docWord} ${t}`;
};
